const number = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const buildXReportPrintSummaryRows = ({ salesSummary, reserves, adjustments }) => {
  const cashIn = number(adjustments?.cash_in);
  const cashOut = number(adjustments?.cash_out);
  const hasAdjustment = Math.abs(cashIn) > 0.000001 || Math.abs(cashOut) > 0.000001;
  return [
    { label: "Brut", amount: number(salesSummary?.gross_sales), prefix: "" },
    { label: "Remises", amount: number(salesSummary?.total_discounts), prefix: "-" },
    { label: "À crédit", amount: number(salesSummary?.total_credit_sales), prefix: "-" },
    { label: "Réserves utilisées", amount: number(reserves?.redeemedMinor) / 100, prefix: "-" },
    ...(hasAdjustment
      ? [
          { label: "Dépôts", amount: cashIn, prefix: "+" },
          { label: "Retraits", amount: cashOut, prefix: "-" },
        ]
      : []),
    { label: "Net", amount: number(salesSummary?.net_sales), prefix: "", strong: true },
  ];
};

module.exports = { buildXReportPrintSummaryRows };
